import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ addressId, attachId, acceptanceClientId }) =>
  request.delete(
    `Acceptance/address/${addressId}/attachment`,
    { attachId, acceptanceClientId },
    'Не удалось удалить документ',
    'Error'
  );

export const useDeleteAttachment = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error') {
        if (typeof options?.onSuccess === 'function') {
          options.onSuccess(data, variables);
        }
      }
    },
  });
